<template>
    <div>
        <Topheader></Topheader>
        <div class="w1100 content-body">
            <div class="con-body">

                <div class="title-body">
                    <div class="title-t">查看已回答（{{total}}）</div>
                    <div class="back-btn" @click="$router.go(-1)">返回</div>
                </div>

                <div class="list-body">
                    <div class="list-content" v-for="(vo,key) in list" :key="key">
                        <div class="head-body">
                            <el-image class="head-img" :src="vo.answer_user_head" fit="cover"></el-image>
                            <div class="user-name">{{vo.answer_user_name}}</div>
                        </div>
                        <div class="q-info">{{vo.question_info}}</div>
                        <div class="hd-time">{{vo.answer_time}} 回答问题</div>
                        <div class="aninfo">{{vo.result_info}}</div>

                        <div class="ask-interflow">
                            <div class="ask-input-body">
                                <input type="text"  @focus="focusInput(key)" @blur="hideInput(key)" v-model="vo.interflowContent" placeholder="Interflow…">
                            </div>
                            <div class="button" :class="vo.interflowContent ? 'active' : ''" v-show="vo.is_focus == true" @click="subInterflow(key)">Post</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div style="margin-top: 40px;"
             class="loading"
             v-loading="loading"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(246, 246, 246, 0.8)"
        ></div>
        {{inputStr}}
    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片

    export default {
        components: {
            Topheader
        },
        name: "wendaList",
        data() {
            return {
                interflowContent: '',
                is_focus:false,
                loading: false,
                loadingType:0,//0=可以加载 1=加载中 2=已加载完毕
                page:1,
                list:[],
                inputStr:'',
                total:0,
            };
        },
        created() {
            this.getList();//请求数据
            window.addEventListener("scroll", this.onScroll);
        },
        //方法定义
        methods: {
            //留言
            subInterflow(key) {
                let _this = this;
                if (!_this.list[key].interflowContent) {
                    this.hideInput(key);
                    return;
                }
                let data = {
                    dynamic_id: _this.list[key].dynamic_id,
                    content: _this.list[key].interflowContent,
                    page_num: 3
                };
                _this.common.request(
                    "api/dynamicLeave/interflow",
                    data,
                    function(res) {
                        if (res.status == 200) {
                            _this.common.vMessage(res.message);
                            _this.list[key].leave_num = res.data.leave_num;
                            _this.list[key].leaveList = res.data.leaveList; //更新发言
                            _this.list[key].interflowContent = null;
                            _this.blurInput(key);
                        }
                    },
                    "post"
                );
            },
            /*临时使用方法*/
            focusInputNew(){
                this. is_focus=!this.is_focus;
            },
            focusInput(key) {
                for (let i = 0; i < this.list.length; i++) {
                    this.list[i].is_focus = false;
                }
                this.list[key].is_focus = true;
                this.inputStr += " ";
            },
            hideInput(key) {
                if (!this.list[key].interflowContent) {
                    this.list[key].is_focus = false;
                    this.inputStr += " ";
                }
            },
            //获取list
            getList(){
                let _this=this;
                _this.page=1;
                let data={
                    page:_this.page,
                    page_num:_this.common.pageNum()
                };
                _this.common.request('api/question/toMyAnswerList',data,function (res) {
                    if(res.status == 200){
                        _this.list=res.data.list;
                        _this.total=res.data.total;
                    }
                })

            },
            //加载跟多
            onScroll() {
                //可滚动容器的高度
                let innerHeight = document.querySelector("#app").clientHeight;
                //屏幕尺寸高度
                let outerHeight = document.documentElement.clientHeight;
                //可滚动容器超出当前窗口显示范围的高度
                let scrollTop = document.documentElement.scrollTop;
                //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
                if (innerHeight <= outerHeight + scrollTop) {
                    let _this=this;
                    if (_this.loadingType != 0) {
                        return;
                    }
                    _this.loadingType = 1;
                    _this.loading=true;
                    _this.page++;
                    let list=[];
                    let data={
                        page:_this.page,
                        page_num:_this.common.pageNum()
                    };
                    _this.common.request('api/question/toMyAnswerList',data,function (res) {
                        if(res.status == 200){
                            list=res.data.list;//请求数据
                            _this.loading=false;
                            if (list.length <=0) {
                                _this.loadingType = 2;
                                return;
                            }
                            _this.list = _this.list.concat(list);
                            _this.loadingType = 0;
                        }
                    });

                }
            }
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">
.content-body{
    min-height:700px;
    background:rgba(255,255,255,1);
    margin-top: 20px;
}
.con-body{
    width: 1060px;
    margin: 0 auto;
}
    .title-body{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 60px;
    }
    .title-t{
        font-size:24px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(72,72,72,1);
    }
    .back-btn{
        font-size:16px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(72,141,189,1);
        cursor: pointer;
        margin-left: 20px;
    }
.back-btn:hover{
    color:rgba(72,141,189,0.8);
}

    .list-content{
        padding: 10px 0;
        border-bottom: 1px solid #E7E7E7;
    }
    .head-body{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .head-img{
        width:48px;
        height:48px;
        border-radius:50%;
    }
    .user-name{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        margin-left: 16px;
    }
    .q-info{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(152,152,152,1);
        margin-top: 10px;
    }
    .hd-time{
        font-size:12px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(152,152,152,1);
    }

    .aninfo{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        line-height:30px;
        margin-top: 10px;
    }

.ask-interflow{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 26px;
}
.ask-input-body{
    width: 1000px;
}
.button {
    color: #15a3f5;
    font-size: 14px;
    width: 62px;
    height: 26px;
    line-height: 26px;
    background: #e8e8e8;
    border-radius: 13px;
    text-align: center;
    cursor: pointer;
}
.button.active {
    color: #fff;
    background: #15a3f5;
}
.button:hover {
    color: #fff;
    background: #15a3f5;
}
</style>


// WEBPACK FOOTER //
// src/view/wendaList.vue